<template>
  <div class="d-flex justify-content-center align-items-center body-content confirmation-wrapper">
    <div class="text-center confirmation-content">
      <p class="font-28 heading-text">
        認証が完了しました！
      </p>
      <p class="font-24 mb-8">
        Bloomキャリア登録を利用する<br />
        大手企業各社へ追加登録が可能です
      </p>
      <button
        class="btn btn-cstm btn-cstm-primary"
        @click="handleOkClick"
        :style="buttonStyle"
      >
        <span class="btn-text-full">次へ（登録可能企業を表示）</span>
        <span class="btn-text-short">次へ</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationPage',
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({
        background: 'red',
        'border-color': 'red'
      })
    }
  },
  methods: {
    handleOkClick() {
      this.$emit('ok-clicked');
    }
  }
};
</script>

<style scoped>
.confirmation-wrapper {
  min-height: 100vh;
}

.confirmation-content {
  max-width: 500px;
  width: 100%;
}

.btn-cstm {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  max-width: 402px;
  height: 57px;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  font-weight: 700 !important;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  color: #fff !important;
  background-color: #006c6b !important;
  border-color: #006c6b !important;
}

.btn-cstm:hover {
  background-color: #005958 !important;
}

.btn-text-short {
  display: none;
}

.font-28 {
  font-size: 24px;
  font-weight: 700 !important;
}

.heading-text {
  margin-bottom: 60px;
}

.font-24 {
  font-size: 24px;
  font-weight: 700 !important;
  text-align: center;
}

.mb-8 {
  margin-bottom: 30px !important;
}

@media (max-width: 768px) {
  .confirmation-wrapper {
    min-height: 75vh;
    padding-top: 40px;
  }

  .btn-cstm {
    width: 198px !important;
    max-width: 198px !important;
    height: 35px !important;
    padding: 10px;
    font-size: 20px;
    margin-top: 0 !important;
  }

  .btn-text-full {
    display: none;
  }

  .btn-text-short {
    display: inline;
  }

  .heading-text {
    margin-bottom: 50px;
  }

  .mb-8 {
    margin-bottom: 16px !important;
  }
}
</style> 